import { css } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import CompactCareerRoleCard from 'bundles/front-page/components/modules/career-academy/CompactCareerRoleCard';

import _t from 'i18n!nls/front-page';

const styles = {
  section: css`
    margin-bottom: var(--cds-spacing-400);
  `,

  cards: css`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: hidden;
    padding: var(--cds-spacing-150);
    margin: calc(var(--cds-spacing-150) * -1);
  `,
};

// TODO (MERCH-1769): Remove mock data / fetch in hook when working on renderer
const careerRoleCard = {
  id: 'cyber-security-analyst',
  name: 'Cyber Security Analyst',
  shortDescription:
    "A Cyber Security Analyst monitors and secures an organization's IT infrastructure. They analyze threats, identify vulnerabilities, and implement security measures to protect sensitive data from cyber attacks.",
  roleCardImageUrl:
    'https://images.ctfassets.net/00atxywtfxvd/WslreKdXXAeCwERKLCllJ/64064536b4aba8be21f8cb5e9d4cf697/Cyber_Security_Analyst-role-card_2x.png',
  imagePrimaryColor: `var(--cds-color-blue-25)`,
  slug: 'cyber-security-analyst',
  jobPostingData: {
    medianSalary: 100000,
    numJobsAvailable: 1000,
    currencyCode: 'USD',
  },
};

const CareerAcademyModuleRedesignModuleRenderer = () => {
  return (
    <Section title={_t('Explore in-demand careers')} css={styles.section}>
      <Grid css={styles.cards}>
        <CompactCareerRoleCard {...careerRoleCard} />
        <CompactCareerRoleCard {...careerRoleCard} showLoadingState={true} />
      </Grid>
    </Section>
  );
};

export default CareerAcademyModuleRedesignModuleRenderer;
